// Province metadata used to dynamically render /zone/:slug landing pages.
// Region values: "Toscana" | "Liguria" | "Umbria" | "Lazio".
// Each province has localized content blocks (intro, symptoms) tailored for SEO.

export const provinces = [
  // ===================== TOSCANA =====================
  {
    slug: "firenze", name: "Firenze", region: "Toscana",
    intro_it: "Firenze ha tante case storiche con impianti idraulici stratificati nel tempo: travertino, cotto, pavimenti antichi. Per questo a Firenze contiamo molto sulla diagnosi non distruttiva.",
    intro_en: "Florence has many historic homes with layered plumbing: travertine, terracotta, antique floors. Non-destructive diagnosis is essential here.",
    symptoms_it: ["Macchie d'umidit\u00e0 sui muri perimetrali", "Bollette idriche raddoppiate negli ultimi mesi", "Calo di pressione ai piani alti dei condomini", "Infiltrazioni dai tetti in coppi del centro storico"],
    symptoms_en: ["Damp stains on perimeter walls", "Water bills doubled in recent months", "Pressure drops on upper floors of condos", "Roof leaks from clay tiles in the historic center"],
    nearby: ["prato", "pistoia", "siena", "arezzo"],
  },
  {
    slug: "pisa", name: "Pisa", region: "Toscana",
    intro_it: "A Pisa interveniamo spesso su immobili vicini all'Arno e in zone con falde alte: l'umidit\u00e0 di risalita pu\u00f2 confondere una vera perdita. Il nostro metodo distingue le due cause.",
    intro_en: "In Pisa we often work on properties near the Arno and high-water-table areas: rising damp can be mistaken for leaks. Our method distinguishes them.",
    symptoms_it: ["Macchie in basso ai muri (risalita) vs in alto (perdita)", "Pavimenti freddi al tatto", "Calo di pressione nei rubinetti"],
    symptoms_en: ["Stains low on walls (rising) vs high (leak)", "Cold spots on floors", "Tap pressure drops"],
    nearby: ["livorno", "lucca", "firenze"],
  },
  {
    slug: "grosseto", name: "Grosseto", region: "Toscana",
    intro_it: "In Maremma molte case hanno giardini ampi e tratti interrati lunghi: un punto da verificare sono i tubi dell'irrigazione e le linee esterne.",
    intro_en: "In Maremma many homes have wide gardens and long buried lines: leaks in irrigation pipes and external lines are very common.",
    symptoms_it: ["Zone di erba pi\u00f9 verde improvvise", "Contatore che gira con tutto chiuso", "Pressione bassa in casa"],
    symptoms_en: ["Sudden greener grass patches", "Meter spinning with everything closed", "Low pressure in the house"],
    nearby: ["siena", "livorno", "viterbo"],
  },
  {
    slug: "livorno", name: "Livorno", region: "Toscana",
    intro_it: "Livorno e il litorale: aria salmastra, edifici storici e seconde case. Interveniamo H24 anche su immobili non abitati per limitare i danni quando il proprietario non \u00e8 in sede.",
    intro_en: "Livorno and the coast: salty air, historic buildings, second homes. We respond 24/7 even on unoccupied properties to limit damage.",
    symptoms_it: ["Salnitro sui muri", "Bollette anomale in case vuote", "Perdite sotto piastrelle del bagno"],
    symptoms_en: ["Salt efflorescence on walls", "Unusual bills in empty homes", "Leaks under bathroom tiles"],
    nearby: ["pisa", "grosseto", "lucca"],
  },
  {
    slug: "lucca", name: "Lucca", region: "Toscana",
    intro_it: "Mura, palazzi storici e ville: a Lucca abbiamo l'esperienza per intervenire dove non si pu\u00f2 rompere. Strumentazione di precisione e rispetto per gli interni di pregio.",
    intro_en: "Walls, historic buildings and villas: in Lucca we have the experience to work where nothing can be broken. Precision tools and respect for valuable interiors.",
    symptoms_it: ["Aloni sui soffitti di palazzi antichi", "Pavimenti in cotto con umidit\u00e0 a chiazze", "Tetti in coppi con perdite localizzate"],
    symptoms_en: ["Stains on antique ceilings", "Patchy damp on terracotta floors", "Localized clay-tile roof leaks"],
    nearby: ["pisa", "pistoia", "massa-carrara"],
  },
  {
    slug: "pistoia", name: "Pistoia", region: "Toscana",
    intro_it: "Pistoia citt\u00e0 e vivai: case storiche in centro e capannoni produttivi nell'area dei vivai. Trattiamo entrambi con la stessa precisione. Sede operativa a Massa e Cozzile.",
    intro_en: "Pistoia city and nurseries: historic homes downtown and production warehouses in the nursery area. Same precision for both. HQ in Massa e Cozzile.",
    symptoms_it: ["Tubazioni industriali con perdite micro", "Umidit\u00e0 nei piani terra", "Tetti in lamiera che gocciolano"],
    symptoms_en: ["Industrial pipes with micro-leaks", "Ground-floor moisture", "Dripping sheet-metal roofs"],
    nearby: ["prato", "firenze", "lucca"],
  },
  {
    slug: "prato", name: "Prato", region: "Toscana",
    intro_it: "Prato \u00e8 fatta di condomini moderni e capannoni tessili: due tipi di impianti diversi, entrambi soggetti a perdite tipiche. Conosciamo bene le criticit\u00e0 locali.",
    intro_en: "Prato has modern condos and textile warehouses: two different system types, both with typical leak patterns we know well.",
    symptoms_it: ["Macchie sui pianerottoli condominiali", "Cali di pressione in stabilimenti", "Perdite negli scarichi industriali"],
    symptoms_en: ["Stains on condo landings", "Plant pressure drops", "Leaks in industrial drains"],
    nearby: ["firenze", "pistoia"],
  },
  {
    slug: "siena", name: "Siena", region: "Toscana",
    intro_it: "Siena, Val d'Orcia, Chianti: agriturismi, case coloniche e palazzi nobili. Affrontiamo impianti complessi, spesso misti tra storico e nuovo.",
    intro_en: "Siena, Val d'Orcia, Chianti: farmstays, country houses, noble palaces. We handle complex systems often mixing historic and new.",
    symptoms_it: ["Calo pressione su pi\u00f9 unit\u00e0", "Tetti di agriturismi con infiltrazioni", "Bolletta alta su seconde case"],
    symptoms_en: ["Pressure drops across multiple units", "Roof leaks at farm stays", "High bills on second homes"],
    nearby: ["firenze", "arezzo", "grosseto"],
  },
  {
    slug: "arezzo", name: "Arezzo", region: "Toscana",
    intro_it: "Arezzo e Valtiberina: terreni argillosi e impianti spesso stratificati. Strumentazione corretta = niente demolizioni inutili.",
    intro_en: "Arezzo and Valtiberina: clay soils and layered systems. The right tools mean no useless demolitions.",
    symptoms_it: ["Allagamenti puntuali in cantina", "Tetti che perdono dopo forti piogge", "Umidit\u00e0 nei muri perimetrali"],
    symptoms_en: ["Cellar localized flooding", "Roofs leaking after heavy rain", "Damp perimeter walls"],
    nearby: ["siena", "firenze", "perugia"],
  },
  {
    slug: "massa-carrara", name: "Massa-Carrara", region: "Toscana",
    intro_it: "Massa e Carrara: vicinanza al mare, ville e case sui colli. Esperienza specifica su tetti esposti e su impianti soggetti a salsedine.",
    intro_en: "Massa and Carrara: sea proximity, villas and hillside homes. Specific expertise on exposed roofs and salt-prone systems.",
    symptoms_it: ["Tegole spostate dal vento", "Bollette anomale in case di villeggiatura", "Ossidazione visibile sui tubi esterni"],
    symptoms_en: ["Wind-displaced tiles", "Unusual bills in vacation homes", "Visible pipe oxidation"],
    nearby: ["la-spezia", "lucca"],
  },

  // ===================== LIGURIA =====================
  {
    slug: "la-spezia", name: "La Spezia", region: "Liguria",
    intro_it: "La Spezia: porto, citt\u00e0 storica e Cinque Terre. Operiamo H24 con tecnici abituati a centri storici stretti e case su pendio.",
    intro_en: "La Spezia: port, historic city and Cinque Terre. We operate 24/7 with technicians used to tight historic centers and hillside homes.",
    symptoms_it: ["Infiltrazioni in case di villeggiatura", "Tetti di antiche case di pescatori", "Perdite negli scarichi pluviali"],
    symptoms_en: ["Vacation-home infiltrations", "Old fisherman-house roofs", "Rainwater drain leaks"],
    nearby: ["massa-carrara", "lucca", "genova"],
  },
  {
    slug: "genova", name: "Genova", region: "Liguria",
    intro_it: "Genova: caruggi, palazzi storici, case sui colli e attivit\u00e0 portuali. Le perdite qui si nascondono in muri spessi, tubi misti, sottoscale ciechi. Strumentazione non distruttiva indispensabile.",
    intro_en: "Genoa: old alleys, historic palaces, hillside homes and port businesses. Leaks hide in thick walls, mixed pipes and blind crawl spaces. Non-destructive tools are essential.",
    symptoms_it: ["Aloni sui muri di palazzi storici", "Bollette alte in alloggi turistici", "Perdite in canne pluviali condominiali", "Tubi in piombo o ferro corrosi"],
    symptoms_en: ["Stains on historic-palace walls", "High bills in holiday rentals", "Leaks in condo rainwater stacks", "Corroded lead/iron pipes"],
    nearby: ["savona", "la-spezia"],
  },
  {
    slug: "savona", name: "Savona", region: "Liguria",
    intro_it: "Savona e Riviera delle Palme: spiagge, ville di villeggiatura e centri storici medievali. Interveniamo H24 anche su seconde case con proprietari fuori sede.",
    intro_en: "Savona and the Palm Riviera: beaches, holiday villas and medieval centers. 24/7 service including absent-owner properties.",
    symptoms_it: ["Salsedine su tubi e fittings", "Bollette anomale in case chiuse l'inverno", "Perdite in piscine private", "Infiltrazioni in seminterrati vicini al mare"],
    symptoms_en: ["Salt buildup on pipes and fittings", "Anomalous winter bills", "Private pool leaks", "Basement infiltrations near sea"],
    nearby: ["genova", "imperia"],
  },
  {
    slug: "imperia", name: "Imperia", region: "Liguria",
    intro_it: "Imperia e Riviera di Ponente: Sanremo, Bordighera, frazioni collinari con uliveti. Conosciamo bene le tubazioni di irrigazione e gli impianti di ville d'epoca.",
    intro_en: "Imperia and Western Riviera: Sanremo, Bordighera, olive-hill hamlets. Expert in irrigation lines and period-villa plumbing.",
    symptoms_it: ["Perdite in linee di irrigazione olivicola", "Umidit\u00e0 in ville liberty", "Cali pressione in alberghi sulla costa"],
    symptoms_en: ["Olive-grove irrigation leaks", "Damp in liberty villas", "Pressure drops in coastal hotels"],
    nearby: ["savona", "genova"],
  },

  // ===================== UMBRIA =====================
  {
    slug: "perugia", name: "Perugia", region: "Umbria",
    intro_it: "Perugia, Assisi, Lago Trasimeno: centri storici, case di campagna, agriturismi. Conosciamo bene le tipologie costruttive umbre.",
    intro_en: "Perugia, Assisi, Lake Trasimeno: historic centers, country homes, farm stays. We know the local building types well.",
    symptoms_it: ["Umidit\u00e0 in case in pietra", "Tetti in coppi che perdono", "Cisterne e pozzi che si svuotano", "Bolletta anomala in agriturismi"],
    symptoms_en: ["Damp in stone houses", "Leaking clay roofs", "Emptying cisterns and wells", "Anomalous bills at farm stays"],
    nearby: ["terni", "arezzo", "viterbo", "rieti"],
  },
  {
    slug: "terni", name: "Terni", region: "Umbria",
    intro_it: "Terni, Orvieto, valnerina: impianti industriali, condomini moderni, ville di pregio. Ogni intervento con metodo non distruttivo.",
    intro_en: "Terni, Orvieto, Valnerina: industrial systems, modern condos, premium villas. Every job is non-destructive.",
    symptoms_it: ["Tubi vecchi in zinco con perdite diffuse", "Macchie su soffitti recenti", "Pressione ballerina"],
    symptoms_en: ["Old zinc pipes with diffuse leaks", "Stains on recent ceilings", "Erratic pressure"],
    nearby: ["perugia", "viterbo", "rieti"],
  },

  // ===================== LAZIO (Alto Lazio) =====================
  {
    slug: "viterbo", name: "Viterbo", region: "Lazio",
    intro_it: "Viterbo, Tarquinia, Bolsena: tufo, case di campagna, terme. Strumentazione adatta anche a murature spesse e materiali tipici.",
    intro_en: "Viterbo, Tarquinia, Bolsena: tuff stone, country homes, thermal baths. Tools suited to thick masonry and local materials.",
    symptoms_it: ["Macchie su tufo (difficile da diagnosticare)", "Tetti in coppi antichi", "Perdite in impianti di piscina/terme"],
    symptoms_en: ["Stains on tuff (hard to diagnose)", "Old clay-tile roofs", "Pool/spa system leaks"],
    nearby: ["rieti", "perugia", "terni", "grosseto"],
  },
  {
    slug: "rieti", name: "Rieti", region: "Lazio",
    intro_it: "Rieti e la Sabina: terreni eterogenei, case storiche, freddo invernale che provoca rotture da gelo. Interveniamo H24 anche per emergenze invernali.",
    intro_en: "Rieti and Sabina: varied soils, historic homes, winter cold that causes freeze breaks. 24/7 also for winter emergencies.",
    symptoms_it: ["Tubi gelati che esplodono", "Bolletta improvvisa dopo l'inverno", "Macchie sui muri perimetrali"],
    symptoms_en: ["Frozen pipes that burst", "Sudden bills after winter", "Stains on perimeter walls"],
    nearby: ["viterbo", "perugia", "terni"],
  },
];

export function provinceBySlug(slug) {
  return provinces.find((p) => p.slug === slug);
}

export function provincesByRegion(region) {
  return provinces.filter((p) => p.region === region);
}
